import "./Media.scss";
import PropTypes from "prop-types";
import MediaVideo from "./MediaVideo";
import MediaImage from "./MediaImage";

export const Media = ({ component, lang }) => {
  const {
    imageVideo,
    imageVideoMobile,
    image4K,
    typeMedia,
    backgroundColor,
    fullWidth,
    videoMode,
    videoUrl,
    marginBottom,
    logo,
    size,
    hideVideoControls,
    showImageFullHeight,
    scaleAnimation,
  } = component.fields;

  const getSize = () => {
    if (size.staticValue[0] !== "default") {
      return size.staticValue[0];
    } else if (fullWidth.staticValue) {
      return "full_width";
    } else {
      return "default";
    }
  };

  return (
    <div className={`geco-media ${marginBottom.staticValue[0]} media-${component.id}`}>
      {typeMedia.staticValue === "Video" ? (
        <MediaVideo
          id={component.id}
          imageVideo={imageVideo.staticValue}
          imageVideoMobile={imageVideoMobile.staticValue}
          imageVideo4K={image4K.staticValue}
          backgroundColor={backgroundColor.staticValue}
          videoMode={videoMode.staticValue[0]}
          videoUrl={videoUrl.staticValue}
          size={getSize()}
          logo={logo.staticValue}
          hideVideoControls={hideVideoControls.staticValue}
          marginBottom={marginBottom.staticValue[0]}
          lang={lang}
        />
      ) : (
        <MediaImage
          image={imageVideo.staticValue}
          image4K={image4K.staticValue}
          logo={logo.staticValue}
          size={getSize()}
          showImageFullHeight={showImageFullHeight.staticValue}
          scaleAnimation={scaleAnimation.staticValue}
        />
      )}
    </div>
  );
};

Media.propTypes = {
  lang: PropTypes.string.isRequired,
  component: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    controlId: PropTypes.arrayOf(PropTypes.string).isRequired,
    fields: PropTypes.shape({
      imageVideo: PropTypes.shape({
        staticValue: PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          url: PropTypes.string,
          width: PropTypes.number,
          height: PropTypes.number,
          type: PropTypes.string,
        }),
      }),
      imageVideoMobile: PropTypes.shape({
        staticValue: PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          url: PropTypes.string,
          width: PropTypes.number,
          height: PropTypes.number,
          type: PropTypes.string,
        }),
      }),
      image4K: PropTypes.shape({
        staticValue: PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          url: PropTypes.string,
          width: PropTypes.number,
          height: PropTypes.number,
          type: PropTypes.string,
        }),
      }),
      typeMedia: PropTypes.shape({
        staticValue: PropTypes.oneOf(["Image", "Video", "Document"]).isRequired,
      }),
      backgroundColor: PropTypes.shape({ staticValue: PropTypes.string }),
      fullWidth: PropTypes.shape({ staticValue: PropTypes.bool }),
      videoMode: PropTypes.shape({
        staticValue: PropTypes.arrayOf(PropTypes.oneOf(["autoplay_muted", "click_to_play"]).isRequired),
      }),
      videoUrl: PropTypes.shape({ staticValue: PropTypes.string }),
      marginBottom: PropTypes.shape({
        staticValue: PropTypes.arrayOf(
          PropTypes.oneOf(["margin__bottom__0", "margin__bottom__80", "margin__bottom__160", "margin__bottom__240"])
            .isRequired,
        ),
      }),
      logo: PropTypes.shape({
        staticValue: PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          url: PropTypes.string,
          width: PropTypes.number,
          height: PropTypes.number,
          type: PropTypes.string,
        }),
      }),
      size: PropTypes.shape({
        staticValue: PropTypes.arrayOf(PropTypes.oneOf(["default", "full_width", "full_screen"])).isRequired,
      }),
      hideVideoControls: PropTypes.shape({ staticValue: PropTypes.bool }),
      showImageFullHeight: PropTypes.shape({ staticValue: PropTypes.bool }),
      scaleAnimation: PropTypes.shape({ staticValue: PropTypes.bool }),
    }).isRequired,
  }),
};
